module.exports = __webpack_public_path__ + "img/1577512176.d3adcc84.jpg";